<!-- Count indicator -->
<p *ngIf="!viewingLogRow" class="photo-count" [class.warning]="photos.length < 3">
  {{ photos.length }} photo(s) added
  {{ photos.length < minPhotos ? "("+minPhotos+" recommended)" : "" }}
</p>

<!-- Display photos in a grid that adapts based on screen size -->
<div [class]="isMobile ? 'mobile-photo-grid photo-grid' : 'desktop-photo-grid photo-grid'">
  <div class="empty-state" *ngIf="photos.length === 0 && !dataLoading.isLoading">
    <ion-icon name="images-outline" size="large"></ion-icon>
  <p *ngIf="viewingLogRow">No photos attached to this log entry</p>
  <p *ngIf="!viewingLogRow">No photos added yet</p>
  </div>
  

  <ion-card
    [class]="isMobile ? 'mobile-photo-card photo-card' : 'desktop-photo-card photo-card'"
    *ngFor="let photo of photos; let i = index"
  >
    <img
      [src]="photo.url"
      alt="User photo"
      (click)="onOpenPhotoModal(i)"
    />
    <span class="photo-kind-label" *ngIf="showKindLabels && photo.kind" [title]="photo.kind">
      {{ photo.kind }}
    </span>
    <ion-badge class="photo-badge" [color]="badgeColor" *ngIf="badgeText">
      {{ badgeText }}
    </ion-badge>
    <ion-fab
    *ngIf="photosEditable"
      [class]="isMobile ? 'mobile-ion-fab' : 'desktop-ion-fab'"
      vertical="top"
      horizontal="end"
    >
      <ion-fab-button
        color="danger"
        size="small"
        (click)="onDeletePhoto(i)"
      >
        <ion-icon name="trash-outline"></ion-icon>
      </ion-fab-button>
    </ion-fab>
  </ion-card>
</div>

  <!-- Delete All button and Copy To Clipboard button -->
  <div class="action-buttons" *ngIf="photos.length > 0">
    <ion-button *ngIf="photosEditable && !dataLoading.isLoading" color="danger" (click)="onDeleteAllPhotos()">
      <ion-icon name="trash-outline"></ion-icon>
        &nbsp; Delete All  
    </ion-button>
    <ion-button *ngIf="includeCopyPhotos && !dataLoading.isLoading" (click)="copyPhotos()">
      <ion-icon name="copy-outline"></ion-icon>&nbsp; Copy To Clipboard
    </ion-button>
  </div>

<!-- Photo Viewer Modal Component -->
<app-photo-viewer-modal
  [isOpen]="isPhotoModalOpen"
  [photoList]="photos"
  [initialIndex]="selectedPhotoIndex"
  (closeModal)="closePhotoModal()">
</app-photo-viewer-modal>